import * as flexsearch from "flexsearch";

import { search as searchApi } from "apis-v2/callables";
import { IWorkspaceResourceTheme, IWorkspaceResourceWithDocument } from "common/interfaces";
import { IThemesSearchDocument } from "common/interfaces/search/ISearchDocument";

import { BaseWorkspaceResourcesController, BaseWorkspaceResourcesControllerState } from "./BaseWorkspaceResourcesController";

export type IThemesPaneTheme = null;

export type ThemesPaneControllerState = BaseWorkspaceResourcesControllerState<IThemesPaneTheme, IWorkspaceResourceTheme>;

class ThemesPaneController extends BaseWorkspaceResourcesController<IThemesPaneTheme, IWorkspaceResourceTheme, IThemesSearchDocument> {
    protected get _documentFields() {
        return [];
    }

    protected _searchDocumentToResourceWithDocument(searchDocument: IThemesSearchDocument): IWorkspaceResourceWithDocument<IThemesPaneTheme, IWorkspaceResourceTheme> {
        return {
            resource: searchDocument.resource,
            permission: searchDocument.permission,
            document: null,
            composedAt: searchDocument.composedAt,
        };
    }

    protected async _fetchSearchIndex({ locale, workspaceId }: { locale: string, workspaceId: string }): Promise<{ indexConfig: flexsearch.DocumentOptions<any>, indexFileReadUrl: string }> {
        return searchApi.getThemesSearchIndex({ workspaceId, locale });
    }
}

const themesPaneController = new ThemesPaneController();
export default themesPaneController;
